import { schemas } from '@/network/client';

export const getImagesUrlFromContentResponse = (content: schemas['Description']) => {
  const flatten = content.sections?.flatMap((section) => section.items);
  return (
    flatten
      ?.filter((item): item is { type: 'IMAGE'; content: string } => item?.type === 'IMAGE' && !!item?.content)
      .map((item) => item?.content) || []
  );
};
